<template>
  <div id="modulo-iscrizioni" class="iscrizioni-form">
    <div class="row-400-25-default p-top-xl-1 p-bottom-xl-1 max-content">
      <div class="container">
        <div class="left">
          <h3 class="title title-base">Invia una richiesta</h3>
          <p class="text-s-1-b">
            Compilate il form online per richiedere maggiori informazioni o
            fissare una visita della nostra scuola.
          </p>
        </div>
        <div class="right">
          <Form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IscrizioniForm',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
